import { render, staticRenderFns } from "./AssociateReferentToUserModal.vue?vue&type=template&id=365ea644&"
import script from "./AssociateReferentToUserModal.vue?vue&type=script&lang=ts&"
export * from "./AssociateReferentToUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports